import { IconInfo } from '@developerz/ui';
import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';

// "You're back from GitHub" acknowledgement. Presenter.
//
// `apps/api/src/routes/gh-installed.ts` has minted `?gh_setup=<action>` on the
// bounce back from the App install "so the SPA can say which hop the user just
// came back from" — and nothing in this bundle read it, so the funnel greeted a
// returning user with the same screen they left. `request` is the one that
// mattered: a member who cannot install on an org gets a REQUEST, not an
// install, and the funnel's connect step just kept spinning with no hint that it
// is now waiting on another human.
//
// Absent / unrecognised values are still acknowledged rather than dropped: the
// route's own `GhSetupAction` carries an `unknown` catch-all, so a value this
// bundle doesn't know still means "you just came back from GitHub".
const KNOWN: Readonly<Record<string, string>> = {
  install: 'onboarding.gh_setup_install',
  update: 'onboarding.gh_setup_update',
  request: 'onboarding.gh_setup_request',
};

export type OnboardingReturnNoticeProps = {
  /** The `gh_setup` query param, exactly as the API set it. */
  readonly ghSetup: string | string[] | undefined;
};

export function OnboardingReturnNotice(props: OnboardingReturnNoticeProps): JSX.Element {
  const value = (): string | undefined => {
    const raw = props.ghSetup;
    return Array.isArray(raw) ? raw[0] : raw;
  };
  return (
    <Show when={value()}>
      {(action) => (
        <div class="alert alert--icon" role="status">
          <IconInfo />
          <p class="alert__title">{t(KNOWN[action()] ?? 'onboarding.gh_setup_unknown')}</p>
        </div>
      )}
    </Show>
  );
}
